export type ProcessDownloadParameters = {
  data: BlobPart;
  fileName: string;
};

export const processDownload = ({ data, fileName }: ProcessDownloadParameters) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', fileName);
  document.body.append(link);
  link.click();
  link.remove();
};
